import React from "react";
import { TransportsComponent } from "../../Components/Transport/TransportComponent";
import Wrapper from "../../Components/Wrapper/wrapper";

export const Transport = () => {
  return (
    <Wrapper header={"Transport"}>
      <TransportsComponent />
    </Wrapper>
  );
};
